/** @jsx React.DOM */
'use strict';

var React = require('react'),
    Card = require('./Card'),
    update = require('react/lib/update');

var Container = React.createClass({displayName: 'Container',
  getInitialState:function() {
    return {
      cards: [{
        id: 1,
        text: 'Write a cool JS library'
      }, {
        id: 2,
        text: 'Make it generic enough'
      }, {
        id: 3,
        text: 'Write README'
      }, {
        id: 4,
        text: 'Create some examples'
      }, {
        id: 5,
        text: 'Spam in Twitter and IRC to promote it'
      }, {
        id: 6,
        text: '???'
      }, {
        id: 7,
        text: 'PROFIT'
      }]
    };
  },

  moveCard:function(id, afterId) {
    var card = this.state.cards.filter(function(c)  {return c.id === id;})[0],
        afterCard = this.state.cards.filter(function(c)  {return c.id === afterId;})[0],
        cardIndex = this.state.cards.indexOf(card),
        afterIndex = this.state.cards.indexOf(afterCard);

    var stateUpdate = {
      cards: {
        $splice: [
          [cardIndex, 1],
          [afterIndex, 0, card]
        ]
      }
    };

    this.setState(update(this.state, stateUpdate));
  },

  render:function() {
    return (
      React.createElement("div", null, 
        this.state.cards.map(function(card)  {
          return (
            React.createElement(Card, {key: card.id, 
                  id: card.id, 
                  text: card.text, 
                  moveCard: this.moveCard})
          );
        }.bind(this))
      )
    );
  }
});

module.exports = Container;


/*****************
 ** WEBPACK FOOTER
 ** ./_sortable-simple/Container.js
 ** module id = 148
 ** module chunks = 0
 **/